<template>
  <div class="flex flex-col md:flex-row items-center justify-center py-4 bg-gray-50 rounded-lg">
    <router-link class="flex items-center mb-4 md:mb-0 text-primary hover:text-primary-dark transition-colors" :to="{ name: 'tenant-home' }">
      <i class="tmlps-i-arrow-left text-4xl md:text-5xl mr-2"></i>
      <img
        :src="tenant.logo_url ? tenant.logo_url : `${publicPath}img/logo-placeholder.png`"
        class="h-12 w-12 md:h-10 md:w-10 border border-gray-300 shadow-lg"
        :alt="tenant.name"
      />
      <img
        :src="project.logo_url ? project.logo_url : `${publicPath}img/logo-placeholder.png`"
        class="h-12 w-12 md:h-10 md:w-10 border border-gray-300 shadow-lg ml-2"
        :alt="project.name"
      />
      <span class="font-bold text-lg md:text-xl ml-3">{{ project.name }}</span>
    </router-link>

    <nav class="w-full md:flex-grow mt-4 md:mt-0">
      <ul class="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-8">
        <li>
          <router-link
            :to="{ name: 'project-home' }"
            custom
            v-slot="{ href, navigate, isExactActive }"
          >
            <a
              class="block text-base font-semibold text-gray-700 hover:text-primary px-3 py-2 rounded-lg transition-all duration-300"
              :href="href"
              @click="navigate"
            >
              <span :class="{ 'text-primary font-bold': isExactActive }">Cámaras</span>
              <div v-show="isExactActive" class="h-1 bg-primary rounded-t-md mt-1 transition-all duration-300"></div>
            </a>
          </router-link>
        </li>

        <li>
          <router-link
            :to="{ name: 'project-users' }"
            custom
            v-slot="{ href, navigate, isExactActive }"
          >
            <a
              class="block text-base font-semibold text-gray-700 hover:text-primary px-3 py-2 rounded-lg transition-all duration-300"
              :href="href"
              @click="navigate"
            >
              <span :class="{ 'text-primary font-bold': isExactActive }">Usuarios</span>
              <div v-show="isExactActive" class="h-1 bg-primary rounded-t-md mt-1 transition-all duration-300"></div>
            </a>
          </router-link>
        </li>

        <li>
          <router-link
            :to="{ name: 'project-reports' }"
            custom
            v-slot="{ href, navigate, isExactActive }"
          >
            <a
              class="block text-base font-semibold text-gray-700 hover:text-primary px-3 py-2 rounded-lg transition-all duration-300"
              :href="href"
              @click="navigate"
            >
              <span :class="{ 'text-primary font-bold': isExactActive }">Reportes</span>
              <div v-show="isExactActive" class="h-1 bg-primary rounded-t-md mt-1 transition-all duration-300"></div>
            </a>
          </router-link>
        </li>

        <li>
          <router-link
            :to="{ name: 'project-information' }"
            custom
            v-slot="{ href, navigate, isExactActive }"
          >
            <a
              class="block text-base font-semibold text-gray-700 hover:text-primary px-3 py-2 rounded-lg transition-all duration-300"
              :href="href"
              @click="navigate"
            >
              <span :class="{ 'text-primary font-bold': isExactActive }">Información</span>
              <div v-show="isExactActive" class="h-1 bg-primary rounded-t-md mt-1 transition-all duration-300"></div>
            </a>
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'ProjectSubNav',
  props: {
    tenant: { type: Object, required: true },
    project: { type: Object, required: true },
  },
  computed: {
    publicPath() {
      return process.env.BASE_URL;
    },
  },
};
</script>

<style scoped>
.text-primary {
  color: #3490dc;
}
.text-primary-dark {
  color: #2779bd;
}
.bg-primary {
  background-color: #3490dc;
}
.shadow-lg {
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}
.transition-all {
  transition: all 0.3s ease;
}
</style>
